<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <button v-if="selected" class="selected">
    <slot />
  </button>
  <button v-else :disabled="disabled" :title="title" :class="{outstanding: outstanding, shadow: shadow, red: red}">
    <slot />
  </button>
</template>

<script setup>
// eslint-disable-next-line
const props = defineProps({
  disabled: {type: Boolean, default: false},
  outstanding: {type: Boolean, default: false},
  selected: {type: Boolean, default: false},
  title: {type: String, default: ""},
  red: {type: Boolean, default: false},
  shadow: {type: Boolean, default: true}
});
</script>

<style scoped>
button {
  padding: 0.3em 0.6em; /* top/bottom - left/right */
  margin: 0px;
  border-radius: 8px;
  border: 1px solid rgba(207, 207, 207, 0.2);
  text-align: left;
  white-space: nowrap;
  text-shadow: none;
  color: #505050;
  background-color: #efedf1;
  cursor: pointer;
}
button.shadow {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
}
button:focus,
button.outstanding {
  color: white;
  background-color: var(--brand-color);
  opacity: 1;
}
button[disabled],
button[disabled]:focus,
button[disabled].outstanding {
  cursor: default;
  color: rgb(200, 200, 200); /*  F6F5F8 B8B8BA  */
  background-color: #f5f3f7; /* F6F5F8  */
  border: 1px solid rgba(0, 0, 0, 0.01);
}
button[disabled].shadow,
button[disabled].shadow:focus,
button[disabled].outstanding.shadow {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.06);
}
button:hover {
  background-color: #d5d5d5;
}
button:hover.outstanding {
  opacity: 0.85;
}
a:hover:not(:focus) {
  color: #505050; /* when it has focus but not hover, back to normal */
}
button.selected {
  cursor: default;
  border: 1px solid rgba(207, 207, 207, 0);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0);
  text-shadow: none;
  font-weight: 700;
  background-color: transparent;
  letter-spacing: 0.03em;
  opacity: 1;
}
button.selected.shadow {
  text-shadow: rgb(0, 0, 0) 0px 0px 6px;
}
button.selected {
  color: var(--brand-color);
}
button.red,
button.red[disabled] {
  background-color: #dc2204;
  color: white;
}
</style>
